module.exports = __webpack_public_path__ + "media/images/checkmark-8b4c86ff2f1d951e41f3215e37a0e0de.svg";